import React from "react";
import FaIcon from "../Elements/FaIcon";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import JsxHelper from "../Helpers/JsxHelper";

export default class SurveyDatumItem {
  constructor(item) {
    if (item === undefined) {
      this.SurveyDataId = "";
      this.SurveyId = "";
      this.ShopperId = "";
      this.Emailrecipients = "";
      this.IsActive = true;
      this.Target = "Apollo";
      this.OfficialShopDateSassieQuestionId = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.SurveyDataId = item.surveyDataId;
    this.SurveyId = item.surveyId;
    this.ShopperId = item.shopperId;
    this.Emailrecipients = item.emailrecipients;
    this.IsActive = item.isActive;
    this.Target = item.target;
    this.OfficialShopDateSassieQuestionId = item.officialShopDateSassieQuestionId;
  }

  static NameOfTheIdField() {
    return "SurveyDataId";
  }
  static nameOfTheItemDetailList() {
    return "SurveyDatum";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = [];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [
    { tabName: "Questions", tabLabel: "Questions", icon: "fa-solid fa-users", data: [{ name: "Questions", label: "Questions", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" }] },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "SurveyDataId", orderById: "SurveyDataId", data: "SurveyDataId" /*FieldTypesEnum.DataFieldWithDetails*/, minWidth: 50 },
      { label: "SurveyId", orderById: "SurveyId", data: "SurveyId", className: "text-center", minWidth: 50 },
      { label: "ShopperId", orderById: "ShopperId", data: "ShopperId", className: "text-center", minWidth: 50 },
      { label: "Email Recipients", orderById: "Emailrecipients", data: "Emailrecipients", className: "text-center", minWidth: 50 },
      { label: "Target", orderById: "Target", data: "Target", className: "text-center", minWidth: 50 },
      { label: "ShopDate SassieQuestionId", orderById: "OfficialShopDateSassieQuestionId", data: "OfficialShopDateSassieQuestionId", className: "text-center", minWidth: 50 },
      { label: "Is Active?", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive), type: FieldTypesEnum.Email, className: "text-center", minWidth: 50 },
      { label: "Actions", orderById: "", data: SurveyDatumItem.getActionsContent, className: "text-center" },
    ];
  }

  static getActionsContent(item) {
    return (
      <div>
        <FaIcon iconName="fa-solid fa-edit" className="pointer link" tooltipText="Edit" onClick={() => SurveyDatumItem.editFunction(item.AddressId, item)} />
      </div>
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
